import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import {
  fetchInvoiceDetails,
  resetDashboardInvoices,
  fetchDashboardResume,
  fetchLogout
} from 'alelo-logic/actions'
import { utils } from 'alelo-logic'
import { ISODateFormat, capitalize } from 'alelo-logic/utils'
import { Box, Flex } from 'grid-styled'
import { paymentMethodDescription } from '../../../utils/paymentMethods'
import Content from '../../../styles/objects/Content'
import InvoiceComplete from '../../modules/InvoiceComplete'
// import InvoiceFooter from '../../modules/InvoiceFooter'
import InvoiceHeader from '../../modules/InvoiceHeader'
import InvoiceResume from '../../modules/InvoiceResume'
import InvoiceValue from '../../modules/InvoiceValue'
import PlanResume from '../../modules/PlanResume'
import InvoiceDetailsHeaderAmount from '../../elements/InvoiceDetailsHeaderAmount'
import rem from '../../../styles/tools/rem'
import PageLoader from '../../modules/PageLoader'
import { setLoading } from '../../modules/PageLoader/actions'

import { BoxPlanResume, Resume, Structure } from './styles'

class InvoiceDetails extends Component {
  async componentWillMount() {
    this.props.setLoading(true)
    await this.fetchDetails()
  }
  shouldComponentUpdate(nextProps) {
    const hasPlanChange =
      this.props.accountPlans.activePlanId !== nextProps.accountPlans.activePlanId
    if (hasPlanChange) {
      this.props.setLoading(true)
      this.props.invoiceDetails(
        this.props.match.params.id,
        this.props.match.params.fatura,
        this.props.match.params.qtdtransacoes
      )
    }
    return true
  }

  async fetchDetails() {
    const params = this.props.match.params || {}
    this.props.setLoading(true)
    await this.props.fetchResume(params.id)
    await this.props.invoiceDetails(params.id, params.fatura, params.qtdtransacoes).then(resp => {
      this.props.setLoading(false)
    })
  }

  parsePositive = number => (String(number).includes('-') ? number * -1 : number)

  render() {
    const { details, resume, user, bankData, match } = this.props

    const email = user.email || ''
    const vehicles = resume.vehicles || []
    const title = 'Atual'
    const vencimento = 'Em Aberto'
    const faturaId = match.params.fatura

    const currentInvoice = this.props.invoices.data.find(
      invoice => invoice.numero === parseInt(faturaId)
    )

    if (!details) {
      return null
    }

    if (!details) return <PageLoader />

    const invoiceProps = {
      status: currentInvoice ? currentInvoice.status : '',
      email: email,
      nfe: details.linkNFE || '',
      linkFaturaPDF: details.linkFaturaPDF || '',
      linkFaturaCSV: details.linkFaturaCSV || '',
      linkBoleto: details.linkBoleto || '',
      printRef: this.printRef,
      transacoes: details && details.transacoes && details.transacoes.length,
      nsu: currentInvoice ? currentInvoice.nsu : ''
    }

    return (
      <PageLoader>
        {resume && (
          <Structure ref={node => (this.printRef = node)}>
            <InvoiceHeader
              title={
                faturaId === '0' || !details.dataVencimento
                  ? title
                  : !_.isEmpty(details)
                    ? `${capitalize(ISODateFormat(details.dataVencimento, 'MMMM'))}/${ISODateFormat(
                        details.dataVencimento,
                        'YY'
                      )}`
                    : ''
              }
              {...invoiceProps}
            />
            <Resume>
              <Content>
                <Flex align="stretch" justify="space-between">
                  <Box mb={[rem('20px'), 0]} pr={[0, 20]} width={[1, 3 / 12]} />
                  <Box pl={[0, 20]} pb={rem('20px')} pt={rem('20px')} width={[1, 8 / 12]}>
                    <InvoiceValue
                      currentInvoice={!details.dataVencimento && !details.formaPagamento}
                      date={
                        faturaId === '0' || !details.dataVencimento
                          ? vencimento
                          : ISODateFormat(details.dataVencimento)
                      }
                      paymentMethod={
                        !_.isEmpty(details) ? paymentMethodDescription[details.formaPagamento] : ''
                      }
                      bankName={bankData && bankData.bankName ? bankData.bankName : ''}
                      total={
                        !_.isEmpty(details)
                          ? utils.currencyParser(this.parsePositive(details.total))
                          : ''
                      }
                    />
                  </Box>
                </Flex>
              </Content>
            </Resume>
            <Content>
              <Flex mt={[0, rem('35px')]} align="stretch" justify="space-between">
                <Box mb={[rem('20px'), 0]} pr={[0, 20]} width={[1, 3 / 12]}>
                  <BoxPlanResume>
                    <PlanResume
                      active={resume.active}
                      category={resume.category}
                      name={resume.name}
                      vehicles={vehicles.length}
                    />
                  </BoxPlanResume>
                </Box>
                <Box mb={[rem('20px'), 0]} pl={[0, 20]} width={[1, 8 / 12]}>
                  <InvoiceResume
                    benefitsValue={details.totalBeneficios}
                    dataServices={details.servicosVeloe}
                    dataConsumption={details.consumos}
                    subtotalValue={details.subTotal}
                    totalValue={details.total}
                  />
                </Box>
              </Flex>
            </Content>
            {details &&
              details.transacoes &&
              details.exibirTransacoes && <InvoiceComplete data={details} />}
            {details.exibirTransacoes && (
              <InvoiceDetailsHeaderAmount amount={details.total * -1 || 0} />
            )}
            {/* <InvoiceFooter /> */}
          </Structure>
        )}
      </PageLoader>
    )
  }
}

const mapStateToProps = ({ reducer }) => ({
  accountPlans: reducer.accountPlans,
  details: reducer.invoiceDetails.details,
  resume: reducer.dashboardResume,
  user: reducer.account,
  invoices: reducer.dashboardInvoices,
  bankData: reducer.accountPlans.plans.find(
    plan => plan.accountId === reducer.accountPlans.activePlanId
  )
    ? reducer.accountPlans.plans.find(plan => plan.accountId === reducer.accountPlans.activePlanId)
        .debitPaymentData
    : null
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  resetInvoices: () => dispatch(resetDashboardInvoices()),
  invoiceDetails: (planId, faturaId, qtdTransacoes) =>
    dispatch(fetchInvoiceDetails(planId, faturaId, qtdTransacoes))
      .then()
      .catch(resp => {
        if (resp && (resp.status === 401 || resp.status === 403)) {
          dispatch(fetchLogout())
          ownProps.history.push('/conta/login')
        }
      }),

  fetchResume: planId =>
    dispatch(fetchDashboardResume(planId))
      .then()
      .catch(resp => {
        if (resp && (resp.status === 401 || resp.status === 403)) {
          dispatch(fetchLogout())
          ownProps.history.push('/conta/login')
        }
      }),

  setLoading: isLoading => {
    dispatch(setLoading(isLoading))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDetails)



// WEBPACK FOOTER //
// ./src/app/pages/InvoiceDetails/index.js